
 

const CirculationConfig = {

    SmmDBApi: async () => {

        var url = 'react_app_smm_download';
        const text = await fetch(url, {
            method: 'POST'
        })
            .then(response => response.text());

        return text;

    },
     ///網站架構設定
    SitemapConfig: {
        menu: [
            //關於本署
            {
                name: '關於網站',
                items: [
                    {
                        name: '認識循環經濟',
                        to: '/about'
                    }
                ]
            },
            //資源循環分析
            {
                name: '資源循環分析',
                items: [
                    {
                        name: '資源循環分析系統',
                        href: 'https://smmdb.moenv.gov.tw/SMM/WebPage/enter.aspx'
                    },
                    {
                        name: '國家層級物質流指標公開成果',
                        href: 'https://smmdb.moenv.gov.tw/SMM/WebPage/MF_index.aspx'
                    }
                ]
            },
            //資源循環推動
            //{
            //    name: '資源循環推動',
            //    items: [

            //        {
            //            name: '資源循環推動說明',
            //            to: '/resourceRecyclingPromotion'
            //        },
            //        {
            //            name: '歷年推動計畫',
            //            to: '/recycleReport3'
            //        },
            //        {
            //            name: '資源回收再利用年報',
            //            to: '/recycleReport'
            //        },
            //        {
            //            name: '相關法規',
            //            href: 'https://oaout.epa.gov.tw/law/SearchAllResultList.aspx?KW=%E8%B3%87%E6%BA%90%E5%9B%9E%E6%94%B6%E5%86%8D%E5%88%A9%E7%94%A8%E6%B3%95&type=E'
            //        }
            //    ]
            //},
            //訊息中心
            {
                name: '訊息中心',
                items: [
                    {
                        name: '循環經濟新聞',
                        to: '/more/news'
                    },
                    {
                        name: '研討會',
                        to: '/more/seminar'
                    }
                ]
            },
            //資源循環教材
            //{
            //    name: '資源循環教材',
            //    items: [
            //        {
            //            name: '資源循環教材',
            //            to: '/recycleReport2'
            //        },
            //        {
            //            name: '相關資源',
            //            to: '/recycleReport4'
            //        },
            //        {
            //            name: '圖卡懶人包',
            //            to: '/recycleReport5'
            //        },
            //        {
            //            name: '影片',
            //            to: '/recycleReport6'
            //        }
            //        //,
            //        //{
            //        //    name: '分享成果',
            //        //    to: '/recycleReport7'
            //        //}
            //    ]
            //},
            //會議專區
            //{
            //    name: '會議專區',
            //    to: '/meetlist'
            //},
            //友站連結
            {
                name: '友站連結',
                items: [
                    {
                        name: 'C2C TW',
                        href: 'https://www.c2cplatform.tw/'
                    }
                ]
            }]

    }
}

export default CirculationConfig;